import createAction from "../../redux/createAction";
import localeActionstypes from "./localizationActionstypes";
export var storeLocale = createAction(localeActionstypes.SET_LOCALE);

//# sourceMappingURL=actions.js.map